// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthProvider";

const ProtectedRoute = ({ children }) => {
  const { user, userData, authLoading } = useAuth();

  if (authLoading) {
    return <div>Loading...</div>;
  }

  if (!user || !userData) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
